import Items from '../Items';

const MenuHamburguer = ({ navBtn, bondaAdminBtn, navOpen, setNavOpen, activePointProgram }) => {
    return (
        <div className={`lg:hidden fixed inset-0 z-50 ${navOpen ? 'pointer-events-auto' : 'pointer-events-none'}`}>
            <button
                type="button"
                aria-label="Cerrar menu de navegacion"
                onClick={() => setNavOpen(false)}
                className={`absolute inset-0 bg-black/35 transition-opacity duration-200 ${
                    navOpen ? 'opacity-100' : 'opacity-0'
                }`}
            />
            <nav
                className={`mobile-nav-drawer absolute left-0 top-0 h-full w-72 max-w-[82vw] bg-white text-gray-800 shadow-2xl
                    transition-transform duration-300 ease-out ${navOpen ? 'translate-x-0' : '-translate-x-full'}`}
                aria-label="Menu de navegacion"
            >
                <div className="flex items-center justify-between border-b border-gray-200 px-4 py-4">
                    <span className="text-sm font-semibold uppercase tracking-wide text-gray-500">
                        Modulos
                    </span>
                    <button
                        type="button"
                        onClick={() => setNavOpen(false)}
                        className="flex h-8 w-8 items-center justify-center rounded-full text-gray-500 transition hover:bg-gray-100 hover:text-gray-800"
                        aria-label="Cerrar menu"
                    >
                        <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M6 6l12 12M18 6L6 18" />
                        </svg>
                    </button>
                </div>
                <ul className="flex flex-col gap-1 px-3 py-3">
                    <Items
                        navBtn={navBtn}
                        bondaAdminBtn={bondaAdminBtn}
                        activePointProgram={activePointProgram}
                    />
                </ul>
            </nav>
        </div>
    );
};

export default MenuHamburguer;
